export const DRAG_DATA_KEY = 'dragData';
export const DEFAULT_GRID_LAYOUT = 'default';
export const FRAME_ID = 'frameId';
export const UNDRAGGABLE_CONTENT_CLASS = 'undraggableContent';

export const WORKSPACE_WIDGET_DEFAULT_SIZE = {
  w: 10,
  h: 10,
};

export const WORKSPACE_WIDGET_PAGE_SIZE = {
  w: 15,
  h: 20,
};

export const WIDGET_MIN_SIZE_SMALL = {
  minW: 5,
  minH: 5,
};

export const WIDGET_MIN_SIZE_PAGE = {
  minW: 10,
  minH: 10,
};
